/**
 * Config of the JwPlayer
 */
var CONFIG = {
    PROVIDE_LINK: "https://clickyab.com",
    PROVIDE_NAME: "ClickYab",
    SKIP_TEXT: "حذف آگهی",
    DEFAULT_SKIP_TIME: 7,
    DEFAULT_AD_TEXT: "مشاهده آگهی",
    REMAINING_TEXT: "باقیمانده"
};
export default CONFIG;
//# sourceMappingURL=config.js.map